import React from 'react';
import { connect } from 'react-redux';
import { Card, CardActions, CardText } from 'react-toolbox/lib/card';
import { Button } from 'react-toolbox/lib/button';
import Dropdown from 'react-toolbox/lib/dropdown';
import Input from 'react-toolbox/lib/input';
import Checkbox from 'react-toolbox/lib/checkbox';
import { is } from 'immutable';
import _ from 'lodash';

import { list, setInfo } from '~/actions/dashboards';
import Spinner from '~/components/Spinner';
import widgets from '~/widgets.new';

import Styles from './style.scss';

class EditDashboard extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      gridType: '',
      widget: [],
      settings: [],
      name: '',
      location: ''
    };
    if (props.dashboard) {
      const dashboardData = props.dashboard.toJS();
      this.state = { ...this.state, ...dashboardData.info };
    }
  }

  componentDidMount() {
    if (!this.props.dashboard) {
      list(this.props.dispatch, this.context.apiClient);
    }
  }

  componentWillReceiveProps(newProps) {
    if (!is(newProps.dashboard, this.props.dashboard)) {
      const { dashboard } = newProps;
      const dashboardData = dashboard.toJS();

      this.setState(dashboardData.info);
    }
  }

  drawWidgetSettings(index) {
    if (!this.state.widget[index]) {
      return <div>Please select a widget</div>;
    }
    const Widget = _.find(widgets.widgets, {
      name: this.state.widget[index]
    });
    return (
      <div>
        <Widget.settings
          onChange={params => {
            const { settings } = this.state;
            settings[index] = params;
            this.setState({ settings });
          }}
          indata={this.state.settings[index] || ''}
        />
      </div>
    );
  }

  drawWidgetDropdown(index) {
    const widgetList = widgets.widgets.map(widget => {
      return { value: widget.name, label: widget.name };
    });
    return (
      <Dropdown
        label="Widget"
        auto
        onChange={name => {
          const { widget } = this.state;
          widget[index] = name;
          this.setState({ widget });
        }}
        source={widgetList}
        value={this.state.widget[index] || ''}
      />
    );
  }

  drawGrid() {
    console.log('drawGrid', this.state.gridType);
    const grid = _.find(widgets.grids, { name: this.state.gridType });
    if (grid) {
      return grid.parts.map((gridItem, index) => {
        if (gridItem.type === 'holder') {
          return (
            <div
              key={`key_${index}`}
              className={Styles.gridItem}
              style={{
                width: gridItem.width,
                position: 'relative',
                float: 'left',
                maxHeight: gridItem.height
              }}
            >
              <Card className={Styles.gridItemCard}>
                <CardText>
                  {this.drawWidgetDropdown(index)}
                  {this.drawWidgetSettings(index)}
                </CardText>
              </Card>
            </div>
          );
        }
        return <div style={{ clear: 'both' }} />;
      });
    }

    return false;
  }

  saveDashboardSettings() {
    const { dashboard } = this.props;
    const dashboardData = dashboard.toJS();
    const { dashboardId } = dashboardData;
    setInfo(
      this.props.dispatch,
      this.context.apiClient,
      dashboardId,
      this.state
    );
  }

  render() {
    const { dashboard } = this.props;
    if (!dashboard) {
      return (
        <div className={Styles.content}>
          <Spinner />
        </div>
      );
    }
    const dashboardData = dashboard.toJS();

    const gridDropDown = widgets.grids.map(grid => {
      return { value: grid.name, label: grid.name };
    });

    return (
      <div className={Styles.content}>
        <div className={Styles.cardBox}>
          <Card style={{ overflow: 'visible' }}>
            <div className={Styles.title}>
              Edit Dashboard Tv for {dashboardData.shortId}{' '}
              {this.state.name && `(${this.state.name})`}
            </div>
            <div className={Styles.fields}>
              <Input
                className={Styles.field}
                value={this.state.name}
                onChange={name => this.setState({ name })}
                label="Name of dashboard"
              />
              <Input
                className={Styles.field}
                value={this.state.location}
                onChange={location => this.setState({ location })}
                label="Location"
              />
              <Dropdown
                className={Styles.field}
                label="Grid type"
                auto
                onChange={gridType => this.setState({ gridType })}
                source={gridDropDown}
                value={this.state.gridType}
              />
              <Checkbox
                className={Styles.field}
                checked={this.state.showName}
                label="Show name on dashboard"
                onChange={showName => this.setState({ showName })}
              />
            </div>
            <div>{this.drawGrid()}</div>
            <CardActions>
              <Button
                icon="save"
                label="Save"
                primary
                onClick={() => {
                  this.saveDashboardSettings();
                }}
              />
            </CardActions>
          </Card>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, props) => ({
  dashboard: state.getIn(['dashboards', 'item', props.match.params.id], false)
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(
  EditDashboard
);



// WEBPACK FOOTER //
// ./app/pages/DashboardConfig/Item.js